<!--
 * @Author: ghy
 * @Date: 2023-07-17 12:51:36
 * @LastEditors: ghy
 * @LastEditTime: 2023-10-08 09:30:49
 * @Description: 
-->
<template>
  <div id="app">
    <CusHeader v-show="$route.path !== '/login' "/>
    <CusNav @isShowNavFn="isShowNavFn" v-show="$route.path !== '/login' && $route.path !== '/'"/>
    <div class="pro">
      <router-view/>
    </div>
    <CusFooter />
  </div>
</template>

<script>
import CusHeader from '@/components/CusHeader';
import CusNav from '@/components/CusNav';
import CusFooter from '@/components/CusFooter';
export default {
  name: "App",
  components:{
    CusHeader,
    CusNav,
    CusFooter
  },
  data(){
    return {
      isShowNav:true
    }
  },
  methods:{
    isShowNavFn(flag){
      this.isShowNav = flag
    }
  }
};
</script>

<style lang="less">
#app {
  width: 100%;
  display: flex;
  min-height: 100%;
  flex-direction: column;
  align-items: center;
  background-image: url('./assets/bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    font-family: Microsoft YaHei !important;
  .pro {
    width: 1400px;
    flex:1;
    background: rgba(255, 255, 255, 0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue